import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import Button from './Button';
import WalletIcon from './Icons/WalletIcon';
import useSafePush from 'src/hooks/useSafePush';

const SecondaryConnectWalletButton = () => {
	const set = useDriftStore((s) => s.set);
	const router = useRouter();
	const safePush = useSafePush();

	const setPreviousRoute = () => {
		set((s) => {
			s.wallet.lastRouteBeforeConnect = router.asPath;
		});

		safePush('/onboarding/connect');
	};

	return (
		<div className="xs:py-8 sm:py-0">
			<Button.Ghost
				size="MEDIUM"
				className="flex items-center justify-center"
				onClick={setPreviousRoute}
			>
				<Link href="/onboarding/connect" className="flex">
					<>
						<WalletIcon className="mr-2" fill="var(--text-default)" />
						<span className="text-xs text-text-default">Connect</span>
					</>
				</Link>
			</Button.Ghost>
		</div>
	);
};

export default SecondaryConnectWalletButton;
